module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Oblique.2d37708b.woff";